export interface LegalDocumentProps {
  id: string;
  legalDocumentType: number;
  creationDate: string;
  periodValidity: string;
  userName: string;
  legalDocumentSituationType: string;
  legalDocumentClassificationType: number;
  legalDocumentDescription?: string;
  description?: string;
  updatedAt?: string;
  uri?: string;
  userWhoCreatedId?: string;
}

export interface LegalDocumentComponentProps {
  document: LegalDocumentProps;
}

export interface LegalDocumentsProps {
  legalDocumentsAttachments?: LegalDocumentProps[];
}

export const LegalDocumentType = [
  { name: 'Alvará Sanitário/Atas' },
  { name: 'CRT' }
];

export const LegalDocumentClassificationType = [
  { name: 'Documento Final' },
  { name: 'Protocolo' }
];